<template>
    <div class="App_Container">
        <div class="list">
            <div v-for="(ele,key,i) in list" :key="i" class="item">
                <div class="item_title" v-if="key">{{ key }}</div>
                <div class="item_box">
                    <div class="item_i" v-for="item in ele" :key="item.id"  @click="cityClick(item)">
                            <div class="box">
                            <img class="bag" v-if="item.logo" :src="item.logo" />
                            <img class="bag" v-else src="@/assets/images/home/empty_city.png" />
                        </div>
                        <p>{{ item.name }}</p>
                        <!-- 阴影 -->
                        <div class="shadow"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cl-club-list',
    props: {
        clubList:{
            type:Array,
            default: ()=>[]
        }
    },
    data() {
        return {
            list: [],
        }
    },
    watch:{
        clubList:{
            handler(newV){
                if(!newV && !newV.length) {
                    this.list = []
                    return 
                }
                this.list = this.setGroup(newV)
            },
            deep:true,
            immediate:true
        }
    },
    methods: {
    
        setGroup(arr){
            let result = {
                "": []
            }
            arr.forEach(v =>{
                // 启用状态展示
                // if(v.enable){
                if (v.group in result) {
                    result[v.group] = [...result[v.group], v]
                } else {
                    result[v.group] = [].concat(v)
                }
                // }
            })
            return result
        },
        // 俱乐部跳转
        cityClick(row) {
            if (!row.enable) return this.$message.error(this.$t('common.俱乐部已经不可访问'))
            this.$emit('click',row)
        },
    }
}
</script>

<style lang="scss" scoped>
.App_Container {
    box-sizing: border-box;
    padding: 16px 24px 24px;
    background: #f3f3f3;
    height: 100%;
    overflow: auto;
    .list_tit {
        box-sizing: border-box;
        font-size: 16px;
        color: #3a3a3a;
        font-family: SysFontM;
        padding-bottom: 16px;
        margin-right: 24px;
    }

    .list {
        display: flex;
        flex-direction: column;
        justify-content: start;
        flex-wrap: wrap;
        width: 100%;

        // 动画
        .transition {
            transition: all 0.1s linear;
        }

        // 定位
        .position_left {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }
        .item {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            background: #fff;
            margin-bottom: 16px;
            padding: 0 24px;
            box-sizing: border-box;
            border-radius: 8px;
            &:last-child {
                margin-bottom: 0;
            }
        }
        .item_box {
            display: flex;
            flex-wrap: wrap;
            margin-top: 6px;
        }
        .item_title {
            height: 54px;
            line-height: 54px;
            color:#3A3A3A;
            font-size: 16px;
            border-bottom: 1px solid #F3F5F9
        }
        .item_i {
            cursor: pointer;
            position: relative;
            margin-right: 14px;
            width: 170px;
            height: 177px;
            margin-bottom: 24px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            
            .box {
                position: relative;
                border-radius: 24px;
                overflow: hidden;
                width: 130px;
                height: 130px;
                padding: 10px;
                z-index: 1;
                // border: 1px solid #ECECEC;
                .bag {
                    display: block;
                    width: 100%;
                    height: auto;
                    margin: 0 auto;
                    border-radius: 50%;
                }

                .mask {
                    @extend .transition;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 120px;
                    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
                }

                &::after {
                    @extend .transition;
                    @extend .position_left;
                    content: '';
                    bottom: 14px;
                    width: 30px;
                    height: 3px;
                    background: #fff;
                    border-radius: 1.5px;
                    opacity: 0;
                }
            }

            p {
                // @extend .transition;
                // @extend .position_left;
                width: 100%;
                text-align: center;
                line-height: normal;
                font-size: 16px;
                line-height: 22px;
                text-align: center;
                color: #3a3a3a;
                opacity: 0.85;
            }

            .shadow {
                @extend .transition;
                @extend .position_left;
                bottom: 0px;
                width: 120px;
                height: 180px;
                background: #0024af;
                filter: blur(30px);
                border-radius: 24px;
                opacity: 0;
            }

            // 鼠标滑过
            // &:hover {
            //     .box {
            //         p {
            //             bottom: 27px;
            //         }
            //         .mask {
            //             background: linear-gradient(180deg, rgba(0, 39, 162, 0) 0%, #0027A7 100%);
            //         }
            //         &::after {
            //             opacity: 1;
            //         }
            //     }
            //     .shadow {
            //         opacity: 1;
            //     }
            // }
        }
    }
}
</style>
